module.exports = __webpack_public_path__ + "img/image163.d8e1247c.jpg";